import { motion } from "framer-motion";
import { Lock, Link2, Clock, Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PageWrap from "@/fileshare/components/PageWrap";
import { useAuth } from "@/fileshare/context/AuthContext";
import UploadCard from "@/fileshare/components/upload/UploadCard";

function HeroCopy({ isGuest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-blue-500 mb-5">
        <Sparkles className="h-3.5 w-3.5" /> Fast, simple, secure
      </span>
      <h1 className="text-4xl sm:text-5xl font-bold tracking-tighter leading-[1.05] text-slate-900">
        Share files with a single, clean link.
      </h1>
      <p className="mt-5 text-base text-slate-600 leading-relaxed max-w-md">
        Drop a file, get a shareable download link in seconds. No signup needed.
        Add a password, set an expiry, and you&apos;re done.
      </p>
      <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-sm text-slate-500">
        <span className="flex items-center gap-2"><Lock className="h-4 w-4 text-slate-400" /> Password protection</span>
        <span className="flex items-center gap-2"><Clock className="h-4 w-4 text-slate-400" /> Auto-expiry</span>
        <span className="flex items-center gap-2"><Link2 className="h-4 w-4 text-slate-400" /> Custom links</span>
      </div>
      {isGuest && (
        <p className="mt-8 text-sm text-slate-500">
          Need bigger files & a dashboard?{" "}
          <Link to="/fileshares/pricing" className="text-blue-500 font-medium hover:underline">
            See plans <ArrowRight className="inline h-3.5 w-3.5" />
          </Link>
        </p>
      )}
    </motion.div>
  );
}

export default function Home() {
  const { user } = useAuth();
  const tier = user ? user.tier : "free";

  return (
    <PageWrap className="max-w-6xl mx-auto px-6 pt-16 pb-24">
      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <HeroCopy isGuest={!user} />
        </div>
        <div className="lg:col-span-7">
          <UploadCard tier={tier} key={tier} />
        </div>
      </div>
    </PageWrap>
  );
}
